/**
 * Safe error message extraction from unknown error types.
 * @param error - Unknown error object
 * @returns Safely extracted error message string
 */
export const getErrorMessage = (error: unknown): string => {
    if (error instanceof Error) {
        return error.message;
    }
    if (typeof error === 'string') {
        return error;
    }
    try {
        return JSON.stringify(error);
    } catch {
        return String(error);
    }
};
